import Label from "@bit/taillislabs.pega.label";
import { Col, Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Form from "shared/components/Form";
import Input from "shared/components/Form/Input";
import Select from "shared/components/Form/Select";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import { ORGANIZATION_TYPE, SCREENS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";

const Detail = ({ onSubmit, organization, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.ORGANIZATION);
  const navigate = useNavigate();
  const DETAIL = t("DETAIL", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });
  const TYPE = t("TYPE", { returnObjects: true });
  const { id, name, type } = organization;
  return (
    <Formik
      initialValues={{ name, type }}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
      )}
    >
      {({ isValid, handleSubmit, ...formProps }) => [
        <Header
          key={"header"}
          title={DETAIL.HEADER.TITLE}
          subtitle={DETAIL.HEADER.ACTION}
          actions={[
            {
              text: DETAIL.HEADER.DISCARD,
              onClick: cancel,
              type: "gray",
            },
            {
              text: DETAIL.HEADER.DELETE,
              onClick: () =>
                navigate(
                  `${SCREENS.PRIVATE.BROKER.ORGANIZATIONS.DELETE.path}/${id}`
                ),
              type: "danger",
            },
            {
              text: DETAIL.HEADER.SAVE,
              onClick: handleSubmit,
            },
          ]}
        />,
        <Row gutter={[16, 16]} key={"row"}>
          <Col span={24}>
            <Form title={FORM.GENERAL_INFO}>
              <Col lg={24}>
                <Label placeholder={FORM.ID} value={id} />
              </Col>
              <Col lg={12}>
                <Input
                  placeholder={FORM.NAME}
                  {...bindInputProps({ name: "name", ...formProps })}
                />
              </Col>
              <Col lg={12}>
                <Select
                  items={ORGANIZATION_TYPE.map((el) => ({
                    label: TYPE[el],
                    value: el,
                  }))}
                  placeholder={FORM.TYPE}
                  {...bindInputProps({ name: "type", ...formProps })}
                />
              </Col>
            </Form>
          </Col>
        </Row>,
      ]}
    </Formik>
  );
};

export default Detail;
